import React from "react";
import "./Footer.css";
import { useSelector } from "react-redux";

function Footer() {
  const en_es = useSelector((state) => state.translation);
  return (
    <footer className="footer">
      <div className="footer__container container">
        <ul className="footer__list">
          <li>
            <a href="#home" className="footer__link">
              {en_es ? "Home" : "Inicio"}
            </a>
          </li>
          <li>
            <a href="#about" className="footer__link">
              {en_es ? "About" : "Sobre mi"}
            </a>
          </li>
          <li>
            <a href="#skills" className="footer__link">
              {en_es ? "Skills" : "Habilidades"}
            </a>
          </li>
          <li>
            <a href="#github" className="footer__link">
              GitHub
            </a>
          </li>
          <li>
            <a href="#projects" className="footer__link">
              {en_es ? "Projects" : "Proyectos"}
            </a>
          </li>
          <li>
            <a href="#courses" className="footer__link">
              {en_es ? "Courses" : "Cursos"}
            </a>
          </li>
          <li>
            <a href="#testimonials" className="footer__link">
              {en_es ? "Testimonials" : "Testimonios"}
            </a>
          </li>
          <li>
            <a href="#currently-working" className="footer__link">
              {en_es ? "Current Work" : "En desarrollo"}
            </a>
          </li>
          <li>
            <a href="#qualifications" className="footer__link">
              {en_es ? "Experience" : "Experiencia"}
            </a>
          </li>
          <li>
            <a href="#contact" className="footer__link">
              {en_es ? "Contact" : "Contacto"}
            </a>
          </li>
          <li>
            <a href="#faq" className="footer__link">
              FAQ
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/mario-vidal-8138651a1/"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="uil uil-linkedin"></i>
          </a>
          <a
            href="https://github.com/Mjosuex85"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="uil uil-github"></i>
          </a>
        </div>

        <div
          className="footer__social"
          style={{ fontSize: "12px", marginTop: "7px" }}
        >
          {en_es ? "Updated: 04/18/2026" : "Actualizado 18/04/2026"}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
